import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Container } from '../../../../symphony';

import { SlLEContext, SlModalIds } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { FreeHeartScreen } from './FreeHeartScreen/FreeHeartScreen';
import { LockedCard } from './LockedCard/LockedCard';
import { IModals, ModalKeys } from '../../global-interface';
import { SlModal } from '../../../../shared/public/SlModal/SlModal';

export function Modals() {
	const [modals, setModals] = useState<IModals>(null);

	useEffect(() => {
		const { modals$ } = Container.take(SlLEContext, SlDataService);
		const unsubscriber = new Subject<void>();

		modals$
			.pipe(
				filter((m) => !!m),
				takeUntil(unsubscriber),
			)
			.subscribe(setModals);

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	return (
		<div sl-test-data="cmpModals">
			<SlModal id={SlModalIds.freeHeartModal}>
				<FreeHeartScreen />
			</SlModal>
			{modals?.[ModalKeys.LockedCard] ? <LockedCard /> : null}
		</div>
	);
}
